import { compose, lifecycle, withProps, withHandlers, withState } from 'recompose'
import { connect } from 'react-redux'
import isEqual from 'lodash/isEqual'
import isEmpty from 'lodash/isEmpty'
import { handleAddNewVehicle } from 'actions/addVehicle'
import { validateForm } from './helpers'
import BOTProductAndServicesQuote from './BOTProductAndServicesQuote'
import { getActiveVehicle } from 'selectors'
import { getCurrentStore, getCurrentStoreEnableAppointmentFlag } from 'selectors/getCurrentStore'
import { navigateToApptConfirmation } from './actions'
import { TPP_MODAL } from 'constant'
import { getUserData } from 'components/Appointment/selectors'
import { updateProductsCount } from '../../common/hoc/withAddToQuote/actions'
import { setDateData } from 'components/QuickAppointmentPage/actions'
import { getCalendarStartDate } from 'components/common/hoc/withAddToQuote/selectors'
import { resetCalendarStartDate } from 'components/common/hoc/withAddToQuote/actions'

const mapStateToProps = state => {
  const { isPilotStore } = getUserData(state)

  return {
    activeVehicle: getActiveVehicle(state),
    hasStore: Boolean(getCurrentStore(state)),
    currentStore: getCurrentStore(state),
    storeApptEnabled: getCurrentStoreEnableAppointmentFlag(state),
    isPilotStore,
    calendarStartDate: getCalendarStartDate(state)
  }
}

const withImprovedProps = withProps(
  ({ quotedItemAndServices: { products = [], services = []}}) => ({
    hasProductsOrServices: Boolean(products.length || services.length)
  })
)

const withQuoteHandlers = withHandlers({
  onRequestApptClick: ({
    navigateToApptConfirmation,
    setProceedErrors,
    hasActiveVehicle,
    hasStore,
    storeApptEnabled
  }) => () => {
    const errors = validateForm({ hasActiveVehicle, hasStore, storeApptEnabled })
    setProceedErrors(errors)
    if (!errors.length) {
      navigateToApptConfirmation()
    }
  }
})

const withInit = lifecycle({
  componentDidMount() {
    const {
      quotedItemAndServices: { products = [], services = []},
      updateProductsCount,
      initQuote,
      isPilotStore,
      handleTAOSDateTimeUpdate
    } = this.props

    initQuote()
      .then(() => {
        !isPilotStore && handleTAOSDateTimeUpdate()
        isPilotStore && !isEmpty(services) && isEmpty(products) && handleTAOSDateTimeUpdate()
      })

    products && products.length && updateProductsCount(products.length)
  },
  componentDidUpdate({
    activeVehicle: previousVehicle,
    currentStore: previousStore,
    quotedItemAndServices: { products: prevProducts },
    calendarStartDate: prevCalendarStartDate
  }) {
    const {
      activeVehicle,
      currentStore,
      setProceedErrors,
      initQuote,
      quotedItemAndServices: { products = [], services = []},
      updateProductsCount,
      handleTAOSDateTimeUpdate,
      isPilotStore,
      setDateData,
      calendarStartDate,
      resetCalendarStartDate
    } = this.props
    if (!isEqual(previousStore, currentStore) || !isEqual(previousVehicle, activeVehicle)) {
      setProceedErrors([])
      initQuote()
        .then(() => {
          !isPilotStore && handleTAOSDateTimeUpdate()
          isPilotStore && isEmpty(products) && previousStore && !isEmpty(services) && handleTAOSDateTimeUpdate()
        })
    }

    if (!isEqual(products, prevProducts)) {
      updateProductsCount(products.length)

      if (isEmpty(products)) {
        isEmpty(services) && setDateData(null)

        if (!isEmpty(prevProducts) && !isEmpty(services)) {
          setDateData(null)
          calendarStartDate ? resetCalendarStartDate() : handleTAOSDateTimeUpdate()
        }
      }

      !isPilotStore && isEmpty(prevProducts) && !isEmpty(products) && handleTAOSDateTimeUpdate()
    }

    if (!isEqual(prevCalendarStartDate, calendarStartDate)) {
      isPilotStore && handleTAOSDateTimeUpdate()
    }
  }
})

const withTPPHandlers = withHandlers({
  handleShowTPPModal: ({ show }) => () => show(TPP_MODAL),
  handleCloseTPPBanner: ({ setShowTPPBanner }) => () => setShowTPPBanner(false)
})

const withShowTPPBannerState = withState('showTPPBanner', 'setShowTPPBanner', true)

export default compose(
  connect(mapStateToProps, {
    handleAddNewVehicle,
    navigateToApptConfirmation,
    updateProductsCount,
    setDateData,
    resetCalendarStartDate
  }),
  withState('proceedErrors', 'setProceedErrors', []),
  withShowTPPBannerState,
  withImprovedProps,
  withQuoteHandlers,
  withTPPHandlers,
  withInit
)(BOTProductAndServicesQuote)
